var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show())?_c('div',{staticClass:"brackets__empty"},[_c('p',[_vm._v(_vm._s(_vm.$t('No bracket yet.'))+" "),_c('br'),_vm._v(" "+_vm._s(_vm.$t('Close the registration of players to enable generating bracket.')))]),_c('button',{staticClass:"button button-primary",on:{"click":_vm.generate}},[_vm._v(_vm._s(_vm.$t('Generate Brackets')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }